require("@babel/polyfill");
import requireJS from "./require";
import "./repair";
import helper from "./helper";
import url from "./url";
import http from "./http";
import base64 from "./base64";
import md5 from "./md5";
import date from "./date";
import config from "./config";
import flexible from "./flexible";
import component from "./component";
import array from "./array";
import metadata from "./metadata";
import designer from "./designer";
import api from "./api";
import client from "./client";
import layer from "./layer";
import math from "./math";
import express from "./express";
import init from "./init";
import cookies from "./cookies";
import validate from "./validate";
import cachePool from "./cache";
import storage from "./storage";
import idCard from "./idCard";
import transition from "./transition";
import mime from "./filemime";
import buttons from "./buttons";
import driver from "../driver";
import unitTest from "./unitTest";
import custom from "./customer";
import enums from "./enums";
import emit from "./emit";
import ws from "./ws";
import ufunc from "./customMathematical";
// import html from './html';
import safe from "./safe";
import file from "./file";
import chart from "./chart";
import screenFull from "./screenFull";
import ui from "./ui";

import wordToHtml from "./wordToHtml";
import event from "./event";
import sandbox from "./sandbox";
import screenZoom from "./screenZoom";
// import aes from './aes';
import sm from "./sm";
import performance from "./performance";
import scrollbar from "./scrollbar";
import stayTimer from "./stayTimer";

let global = window || global;

let dsf = {};
let curUrl = url.parse(window.location.href);
if (curUrl.searchQuery._debug == "1") {
  window.dsfDebug = true;
  helper.warn("开启debug");
  performance.open();
}
performance.start("创建core");
let _dsf = {
  screenZoom,
  performance,
  ...sm, //国密
  event,
  emit,
  ui,
  sandbox,
  //decimal: Decimal,
  chart,
  version: "5.0",
  init,
  api,
  ...helper,
  url,
  http,
  base64,
  // aes,
  md5,
  flexible,
  date,
  config,
  ...component,
  array,
  global,
  metadata,
  ...requireJS,
  designer,
  client,
  layer,
  math,
  express,
  enums,
  validate,
  cachePool,
  storage,
  idCard,
  idCode: idCard,
  mime,
  buttons,
  driver,
  unitTest,
  custom,
  ws,
  ufunc,
  safe,
  file,
  screenFull,
  stayTimer,
  // htmlParse: function (str) {
  //   return html.parse(str)
  // },
  transition: {
    ...transition
  },
  wordToHtml,
  htmlToText: function (node) {
    let str = [];
    for (let i = 0; i < node.childNodes.length; i++) {
      let c = node.childNodes[i];
      if (c.nodeType == 3) {
        let s = c.nodeValue.replace(/\n|\r|\r\n/g, "");
        str.push(s);
      } else if (c.nodeType == 1) {
        // if(c.innerText.indexOf("2")>=0){
        // }
        let isBlock = $(c).css("display") == "block";
        let tagName = c.tagName.toLowerCase();
        let indent = 0;
        let indentValue = c.style.textIndent || "0px";
        let marginLeftValue = c.style.marginLeft || "0px";
        if (marginLeftValue) {
          marginLeftValue = parseFloat(marginLeftValue);
        }
        if (indentValue) {
          indentValue = parseFloat(indentValue);
        }
        let fontsize = $(c).css("font-size");
        if (fontsize) {
          fontsize = parseFloat(fontsize);
        }
        if (isBlock) {
          indent = indentValue || 0;
          indent = marginLeftValue + indentValue || 0;
        } else {
          indent = marginLeftValue || 0;
        }

        let indentArr = [];
        if (indent && fontsize) {
          let x = Math.ceil(indent / fontsize);
          for (let i = 0; i < x; i++) {
            indentArr.push("　");
          }
        }
        if ($(c).text()) {
          if (isBlock) {
            str.push("\n");
            str.push(...indentArr);
            str.push(dsf.htmlToText(c));
          } else if (tagName == "br") {
            str.push("\n");
          } else {
            str.push(...indentArr);
            str.push(dsf.htmlToText(c));
          }
        }
      }
    }
    return str.join("");
  },
  scrollbar,
  chromeMomoryRelease() {
    //chrome的bug，当一个被聚焦过的文本框被移除，会导致该文本框相关内存无法销毁，
    let input_focus_memory = $("#chrome_input_focus_memory");
    if (input_focus_memory.length <= 0) {
      input_focus_memory = $("<input id='chrome_input_focus_memory' style='position:fixed;opacity:0;top:-9999px;left:-9999px;z-index:-1;transform: scale(0);'>").appendTo(document.body);
    }
    input_focus_memory.focus().blur();
  }
};
dsf = {
  ...dsf,
  ..._dsf
};
if (cookies) {
  dsf.mix(dsf, { cookies: cookies });
}
if (window.$$func) {
  dsf.mix(dsf, { $$func: window.$$func });
  delete window.$$func;
}
performance.end("创建core");

//如果window对象存在则表示在客户端运行，否则使用node的global对象作为全局对象
if (global) {
  performance.start("注入全局对象");

  if (helper.isUnDef(global.$mixins)) {
    global.$mixins = {};
  }
  if (helper.isUnDef(global.$platformRouter)) {
    global.$platformRouter = {
      pc: [],
      mobile: [],
      designer: []
    };
  }
  if (helper.isUnDef(global.$i18n)) {
    global.$i18n = {};
  }
  if (helper.isUnDef(global.$components)) {
    global.$components = {};
  }
  if (helper.isUnDef(global.$platformStore)) {
    global.$platformStore = {};
  }
  if (helper.isUnDef(global.$buttons)) {
    global.$buttons = {
      pc: null,
      mobile: null
    };
  }
  if (helper.isUnDef(global.dsf)) {
    global.dsf = dsf;
  }
  if (dsf.isUnDef(global.$isMobile)) {
    Object.defineProperty(
      global,
      "$isMobile",
      (function () {
        let isMobile = false;
        return {
          get() {
            return isMobile;
          },
          set(v) {
            isMobile = v;
          }
        };
      })()
    );
  }
  global.$const = Object.freeze({
    subTableEmptyRowHash: "__virtual_row_hash__"
  });

  //修改Vue.component函数，将重名组件抛出警告
  // if (window.Vue) {
  //   let urlInfo = url.parse(window.location.href);
  //   if (urlInfo.searchQuery['$test$'] == "1") {
  //     let component = Vue.component;
  //     Vue.component = function (name, options) {
  //       if (name && options) {
  //         let ctrl = Vue.options.components[name];
  //         if (ctrl) {
  //           dsf.warn(name + "组件重复注册");
  //         }
  //       }
  //       component.call(Vue, name, options)
  //     }
  //   }
  // }
  performance.end("注入全局对象");
}

export default dsf;
